// General Policies
const ADMIN_SYSTEM = { key: "ADMIN_SYSTEM", name: "AdminSystem" };

// Organization Policies
const MANAGE_ORG_USERS = { key: "MANAGE_ORG_USERS", name: "ManageOrgUsers" };
const MANAGE_PROJECTS = { key: "MANAGE_PROJECTS", name: "ManageProjects" };
const MANAGE_GANG_MEMBERS = { key: "MANAGE_GANG_MEMBERS", name: "ManageGangMembers" };
const MANAGE_REFERENCE_PROCEDURES = { key: "MANAGE_REFERENCE_PROCEDURES", name: "ManageReferenceProcedures" };
const MANAGE_DOCUMENT_TYPES = { key: "MANAGE_DOCUMENT_TYPES", name: "ManageDocumentTypes" };
const MANAGE_ORG_ROLES = { key: "MANAGE_ORG_ROLES", name: "ManageOrgRoles" };
const MANAGE_LICENCES = { key: "MANAGE_LICENCES", name: "ManageLicences" };
const MANAGE_CONFIGURATION = { key: "MANAGE_CONFIGURATION", name: "ManageConfiguration" };
const MANAGE_ADMIN_ORG_USERS = { key: "MANAGE_ADMIN_ORG_USERS", name: "ManageAdminOrgUsers" };
const MANAGE_OPERATOR_ORG_USERS = { key: "MANAGE_OPERATOR_ORG_USERS", name: "ManageOperatorOrgUsers" };
const MANAGE_ADMIN_ROLES = { key: "MANAGE_ADMIN_ROLES", name: "ManageAdminRoles" };
const MANAGE_PROJECT_ASSIGNMENT_CAP = { key: "MANAGE_PROJECT_ASSIGNMENT_CAP", name: "ManageProjectAssignmentCap" };
const MANAGE_PERMIT_TYPES = { key: "MANAGE_PERMIT_TYPES", name: "ManagePermitTypes" };
const VIEW_ORGANIZATION_DASHBOARD = { key: "VIEW_ORGANIZATION_DASHBOARD", name: "ViewOrganizationDashboard" };

// Project Policies
const ADD_DOCUMENT = { key: "ADD_DOCUMENT", name: "AddDocument" };
const ADD_NEW_DOCUMENT_VERSION = { key: "ADD_NEW_DOCUMENT_VERSION", name: "AddNewDocumentVersion" };
const DELETE_DOCUMENT = { key: "DELETE_DOCUMENT", name: "DeleteDocument" };
const ADD_PERMIT = { key: "ADD_PERMIT", name: "AddPermit" };
const REQUEST_PERMIT = { key: "REQUEST_PERMIT", name: "RequestPermit" };
const VIEW_ALL_PERMITS = { key: "VIEW_ALL_PERMITS", name: "ViewAllPermits" };
const APPROVE_PERMIT_REQUEST = { key: "APPROVE_PERMIT_REQUEST", name: "ApprovePermitRequest" };
const DOWNLOAD_PERMIT_PDF = { key: "DOWNLOAD_PERMIT_PDF", name: "DownloadPermitPdf" };
const EXTEND_PERMIT = { key: "EXTEND_PERMIT", name: "ExtendPermit" };
const COMPLETE_PERMIT = { key: "COMPLETE_PERMIT", name: "CompletePermit" };
const CANCEL_OWN_PERMIT = { key: "CANCEL_OWN_PERMIT", name: "CancelOwnPermit" };
const CANCEL_PERMIT = { key: "CANCEL_PERMIT", name: "CancelPermit" };
const UNDO_CANCELLATION_OWN_PERMIT = { key: "UNDO_CANCELLATION_OWN_PERMIT", name: "UndoCancellationOwnPermit" };
const UNDO_CANCELLATION_PERMIT = { key: "UNDO_CANCELLATION_PERMIT", name: "UndoCancellationPermit" };

export {
  ADMIN_SYSTEM,
  MANAGE_DOCUMENT_TYPES,
  MANAGE_GANG_MEMBERS,
  MANAGE_ORG_USERS,
  MANAGE_PROJECTS,
  MANAGE_CONFIGURATION,
  MANAGE_REFERENCE_PROCEDURES,
  MANAGE_ORG_ROLES,
  MANAGE_LICENCES,
  MANAGE_ADMIN_ORG_USERS,
  MANAGE_OPERATOR_ORG_USERS,
  MANAGE_ADMIN_ROLES,
  MANAGE_PROJECT_ASSIGNMENT_CAP,
  MANAGE_PERMIT_TYPES,
  VIEW_ORGANIZATION_DASHBOARD,
  ADD_DOCUMENT,
  ADD_NEW_DOCUMENT_VERSION,
  DELETE_DOCUMENT,
  ADD_PERMIT,
  REQUEST_PERMIT,
  VIEW_ALL_PERMITS,
  APPROVE_PERMIT_REQUEST,
  DOWNLOAD_PERMIT_PDF,
  EXTEND_PERMIT,
  COMPLETE_PERMIT,
  CANCEL_OWN_PERMIT,
  CANCEL_PERMIT,
  UNDO_CANCELLATION_OWN_PERMIT,
  UNDO_CANCELLATION_PERMIT,
};
